export default __webpack_public_path__ + "static/media/whatsapp.46d0f0ef.svg";